export const FETCH_ITEM_SHARE_INVITE_START = 'FETCH_ITEM_SHARE_INVITE_START';
export const FETCH_ITEM_SHARE_INVITE_SUCCESS =
  'FETCH_ITEM_SHARE_INVITE_SUCCESS';
export const FETCH_ITEM_SHARE_INVITE_FAILED = 'FETCH_ITEM_SHARE_INVITE_FAILED';

export const DELETE_ITEM_SHARE_INVITE_START = 'DELETE_ITEM_SHARE_INVITE_START';
export const DELETE_ITEM_SHARE_INVITE_SUCCESS =
  'DELETE_ITEM_SHARE_INVITE_SUCCESS';
export const DELETE_ITEM_SHARE_INVITE_FAILED =
  'DELETE_ITEM_SHARE_INVITE_FAILED';

export const COPY_ITEM_AND_CREATE_ITEM_SHARE_START =
  'COPY_ITEM_AND_CREATE_ITEM_SHARE_START';
export const COPY_ITEM_AND_CREATE_ITEM_SHARE_SUCCESS =
  'COPY_ITEM_AND_CREATE_ITEM_SHARE_SUCCESS';
export const COPY_ITEM_AND_CREATE_ITEM_SHARE_FAILED =
  'COPY_ITEM_AND_CREATE_ITEM_SHARE_FAILED';

export const UPDATE_QUIZ_DESCRIPTION_SUCCESS =
  'UPDATE_QUIZ_DESCRIPTION_SUCCESS';
export const UPDATE_QUIZ_DESCRIPTION_FAILED = 'UPDATE_QUIZ_DESCRIPTION_FAILED';

export const DELETE_ITEM_SHARE_START = 'DELETE_ITEM_SHARE_START';
export const DELETE_ITEM_SHARE_SUCCESS = 'DELETE_ITEM_SHARE_SUCCESS';
export const DELETE_ITEM_SHARE_FAILED = 'DELETE_ITEM_SHARE_FAILED';

export const FETCH_ASSESSMENT_SUMMARY_START = 'FETCH_ASSESSMENT_SUMMARY_START';
export const FETCH_ASSESSMENT_SUMMARY_SUCCESS =
  'FETCH_ASSESSMENT_SUMMARY_SUCCESS';
export const FETCH_ASSESSMENT_SUMMARY_FAILED =
  'FETCH_ASSESSMENT_SUMMARY_FAILED';

export const UPDATE_ITEM_SHARE_ACTIVE_STATE_START =
  'UPDATE_ITEM_SHARE_ACTIVE_STATE_START';
export const UPDATE_ITEM_SHARE_ACTIVE_STATE_SUCCESS =
  'UPDATE_ITEM_SHARE_ACTIVE_STATE_SUCCESS';
export const UPDATE_ITEM_SHARE_ACTIVE_STATE_FAILED =
  'UPDATE_ITEM_SHARE_ACTIVE_STATE_FAILED';
